// Modules
import styled, { css } from 'styled-components'

interface Theme {
    type: 'fullScreen' | 'smallCenter'
    paddingContainer?: string
}

const variations = {
    fullScreen: css`
        grid-area: body;
        display: flex;
    `,
    smallCenter: css`
        padding: 0 ${({ theme }) => theme.space[4]};
        margin: ${({ theme }) => theme.space[0]} auto;
        @media (min-width: ${({ theme }) => theme.breakpoints[0]}) {
            padding: 0;
            max-width: 22.5em;
        }

        @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
            padding: 0;
            max-width: 27.25em;
        }
    `,
}

export const Container = styled.div<Theme>`
    width: 100%;
    height: 100%;
    ${props => variations[props.type]}
    padding: 24px 16px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`
